// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"258":"36046eb6","721":"23102587","967":"4234143b"}[chunkId] + ".chunk.js";
};